<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  {{ data.message }}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-icon-button (click)="dialogRef.close()">
    <span cdkIcon="outline">cancel</span>
  </button>
</mat-dialog-actions>
